import { getAuthState } from '../../../hooks/useAuth';

let auth = getAuthState()

export const aivGetLists = async (): Promise<any> => {
    try {
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/aiv/list`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            }
        });

        const data = await response.json()

        return data;

    } catch (error) {
        console.error('Error getting lists:', error);
        return false;
    }
};